import { NavLink, useLocation } from "react-router-dom";

export default function Sidebar() {
    const location = useLocation();

    const menuItems = [
        { label: "Taloyhtiö ja rapputyyppi", path: "/taloyhtio-ja-rapputyyppi" },
        { label: "Vesiputkien reititys", path: "/waterpipes" },
        { label: "Sähkökalusteet", path: "/electrical-appliances" },
        { label: "Lämmitys ja laitteet", path: "/heating" },
        { label: "Kylpyhuoneen kalustejärjestys", path: "/furniture-arrangement" },
        { label: "Kylpyhuoneen kalusteet", path: "/furniture" },
        { label: "Muuta", path: "/other" },
    ];

    const currentPage = menuItems.find(item => item.path === location.pathname);

    return (
        <aside className="sidebar-container">

            <div className="breadcrumb">
                <NavLink to="/" className="breadcrumb-link">
                    <i className="fa-regular fa-house" />
                </NavLink>
            {currentPage && (
                <>
                <span className="breadcrumb-separator"> / </span>
                <span className="breadcrumb-current">{currentPage.label}</span>
                </>
            )}
            </div>

            <h3 className="sidebar-title">Suunnitelma</h3>
            <nav className="sidebar-nav">
                {menuItems.map((item) => (
                <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) =>
                    isActive ? "sidebar-link active" : "sidebar-link"
                    }>
                    {item.label}
                </NavLink>
                ))}
            </nav>
        </aside>
    );
}